import { changeProp, initialize } from 'modules/storeSlice';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { validatePlanUploader } from 'utils/validate';
import { useMutation } from 'react-query';
import { updatePlan, uploadPlan } from 'lib/api/place';
import useLoginCheck from 'hooks/common/useLoginCheck';

const usePlanUploader = (
  onClose,
  edit,
  setShowNotiModal,
  setNotiMsg,
  replace,
  spaceId,
  setApply,
) => {
  const dispatch = useDispatch();
  const [errors, setErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState(false);
  const { floor, name, selectedFile, space, addedSpace } = useSelector(
    ({ store }) => ({
      floor: store.spaceRegisterForm.floor,
      name: store.spaceRegisterForm.name,
      selectedFile: store.spaceRegisterForm.selectedFile,
      space: store.registerForm.space,
      addedSpace: store.registerForm.addedSpace,
    }),
  );

  const updatePlanMutation = useMutation(updatePlan, {
    onSuccess: () => {
      setApply(true);
    },
  });

  const uploadPlanMutation = useMutation(uploadPlan, {
    onError: error => {
      if (error.response.status === 413) {
        setShowNotiModal(true);
        setNotiMsg('이미지 용량 초과');
        onClose();
        return;
      }
      if (error.response.status === 500) {
        setShowNotiModal(true);
        setNotiMsg('서버 오류 발생');
        onClose();
        return;
      }
    },
    onSuccess: data => {
      const filePath = data.data.filePath;
      dispatch(
        changeProp({
          obj: 'registerForm',
          key: edit ? 'addedSpace' : 'space',
          value: edit
            ? [
                ...addedSpace,
                {
                  floor,
                  name,
                  filePath,
                },
              ]
            : [
                ...space,
                {
                  floor,
                  name,
                  filePath,
                },
              ],
        }),
      );
      onClose();
    },
  });
  useLoginCheck(uploadPlanMutation.error?.response, () => {
    const formData = new FormData();
    formData.append('image', selectedFile);
    uploadPlanMutation.mutate({ formData });
  });

  useEffect(() => {
    return () => {
      dispatch(initialize('spaceRegisterForm'));
    };
  }, [dispatch]);

  useEffect(() => {
    if (isSubmit && Object.keys(errors).length === 0) {
      const formData = new FormData();
      formData.append('image', selectedFile);
      if (replace) {
        updatePlanMutation.mutate({ id: spaceId, formData });
      } else {
        uploadPlanMutation.mutate({ formData });
      }
      setIsSubmit(false);
    }
  }, [
    isSubmit,
    errors,
    selectedFile,
    uploadPlanMutation,
    updatePlanMutation,
    replace,
    spaceId,
  ]);

  const onSubmit = () => {
    setErrors(validatePlanUploader(name, selectedFile, replace));
    setIsSubmit(true);
  };

  const onChangeImg = e => {
    dispatch(
      changeProp({
        obj: 'spaceRegisterForm',
        key: 'selectedFile',
        value: e.target.files[0],
      }),
    );
  };

  const onChange = e => {
    const { name, value } = e.target;
    dispatch(changeProp({ obj: 'spaceRegisterForm', key: name, value }));
  };

  return {
    name,
    errors,
    uploadPlanMutation,
    onChange,
    onChangeImg,
    onSubmit,
  };
};

export default usePlanUploader;
